import Revenue from "./Revenue";

export default Revenue;
